var map = {
	"./Dock.xlsx": 21828,
	"./Exception.xlsx": 84409,
	"./Product.xlsx": 66970,
	"./bag.xlsx": 14062,
	"./customcountrydevision.xlsx": 61075,
	"./customer.xlsx": 54451,
	"./employee.xlsx": 61382,
	"./gate.xlsx": 72508,
	"./najaCprNumbers.xlsx": 45721,
	"./order.xlsx": 17752,
	"./priceList.xlsx": 68306,
	"./route.xlsx": 49443,
	"./serviceDefine.xlsx": 41,
	"./serviceDefine2.xlsx": 29234,
	"./serviceDelivery.xlsm": 3854,
	"./thirdParty.xlsx": 36947,
	"./transportation.xlsx": 21886,
	"./vehicel.xlsx": 32678,
	"./vehicelMake.xlsx": 57658,
	"./vendor.xlsx": 8209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4981;